import scroll from '../helpers/scroll';

export default class PostHero {

	constructor () {
		const hero = document.getElementById('postHero');

		scroll.listen((percentScrolled) => {
			if (percentScrolled > 1)
				return;

			hero.style.setProperty(
				'--post-hero-y',
				(percentScrolled * 200) + 'px'
			);

			hero.style.setProperty(
				'--post-hero-t',
				String(1 - percentScrolled)
			);
		});
	}

}